"use strict";
exports.__esModule = true;
/**
 * Pattern matching for a sum type defined with ADT
 *
 * ```ts
 * declare const foo: Option<string>
 *
 * pipe(
 *   foo,
 *   match({
 *     none: () => 'none',
 *     some: ({value}) => 'some'
 *   })
 * )
 * ```
 */
function match(matchObj) {
    return function (v) { return matchObj[v._type](v); };
}
exports.match = match;
/**
 * Item-first version of, useful for better inference in some circumstances
 *
 * ```ts
 * declare const foo: Option<string>
 *
 * matchC(foo)({
 *   none: () => 'none',
 *   some: ({value}) => 'some'
 * })
 * ```
 */
function matchI(v) {
    return function (matchObj) { return matchObj[v._type](v); };
}
exports.matchI = matchI;
//# sourceMappingURL=ADT.js.map